import { faExclamationCircle, faPhone } from '@fortawesome/free-solid-svg-icons';
import React, {useState} from 'react';

import './contact.css';

import axios from 'axios';

function Contact() {
  
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNum, setPhoneNum] = useState("")
  const [message, setMessage] = useState("")

  const [feedBack, setFeedback] = useState("")

  const [displaySubmit, setDisplaySubmit] = useState(true)
  

  const handleSubmit = (evt) => {
    setDisplaySubmit(false)
    evt.preventDefault();
    axios.post('https://bulbytech.com/sendMessage',{
        "firstName":firstName,
        "lastName":lastName,
        "phone":phoneNum,
        "emailFrom":email,
        "emailTo":"tmchavez96@gmail.com",
        "message":message
    })
    .then(res => {
        console.log(res.status)
        if(res.status === 200){
            setFeedback("Thanks For Reaching Out! We will be in touch soon! 😁")
        }
    })
    .catch(err => {
        console.log("Error Occured")
        setFeedback("Something went wrong 😡 Please try again 😣")
    })
  }

  return (
    <div className="contact--container">
        <div className="contact--header">
            Have a project in mind? Contact us for a free quote!
        </div>
        <div className="form--container">
            <form className="contact--form" onSubmit={handleSubmit}>
                <div className="name--container">
                    <div className="form--item">
                        <label className="form--label">First Name</label>
                        <input className="form--in" type="text" value={firstName} onChange={e => setFirstName(e.target.value)} max="25" required/>
                    </div>
                    <div className="form--item">
                        <label className="form--label">Last Name</label>
                        <input className="form--in" type="text" value={lastName} onChange={e => setLastName(e.target.value)} max="25" required/>
                    </div>
                </div>
                <div className="email--container">
                    <div className="form--item">
                        <label className="form--label">Phone</label>
                        <input className="form--in" type="tel" value={phoneNum} onChange={e => setPhoneNum(e.target.value)} max="25" required/>
                    </div>
                </div>
                <div className="email--container">
                    <div className="form--item">
                        <label className="form--label">Email</label>
                        <input className="form--in" type="email" value={email} onChange={e => setEmail(e.target.value)} max="25" required/>
                    </div>
                </div>
                <div className="message--container">
                    <div className="form--item--message">
                        <label className="form--label">Message</label>
                        <textarea className="form--in" id="message" name="message" value={message} onChange={e => setMessage(e.target.value)} ></textarea>
                    </div>
                </div>
                <div className="button--container">
            
                    <button className={displaySubmit ? "submit--button" : "hide"} type="submit"> Submit </button>
                    
                </div>
                <div className="feedBack">
                    {feedBack}
                </div>
            </form>

            <div className="john--lennon">
                "A dream you dream alone is only a dream. A dream you dream together is reality."
                <p>
                    <i>
                    -John Lennon
                    </i>
                </p>
            </div>
        </div>
    </div>
  );
}

export default Contact;
